// extracted by mini-css-extract-plugin
export var productImage = "_n4-1";
export var viewLink = "_n4-2";
export var wishlistItem = "_n4-0";